export const categoryImageUrl = (image) =>
  image ? `/.netlify/functions/categories-images?key=${encodeURIComponent(image.blobKey)}` : '';

export const sortedDressImages = (dress) =>
  (dress && dress.images ? dress.images : []).slice().sort((a, b) => a.order - b.order);
